import React, { useEffect, useState } from "react";
import { api, brl } from "../lib/api";
import { Crown, Medal, Trophy, Diamond, Star } from "@phosphor-icons/react";

const VIP_ICONS = {
  diamante:  { Icon: Diamond, color: "#5C7CFA", bg: "#E8EEFF" },
  ouro:      { Icon: Crown,   color: "#C5A566", bg: "#F6EAD2" },
  prata:     { Icon: Medal,   color: "#5C5A57", bg: "#EDEAE7" },
  bronze:    { Icon: Trophy,  color: "#9C7155", bg: "#F2E3D8" },
  iniciante: { Icon: Star,    color: "#5C5A57", bg: "#F5F0EB" },
};

export default function VIPCard({ profile }) {
  if (!profile) return null;
  const tierKey = profile.tier?.key || "iniciante";
  const tierConfig = VIP_ICONS[tierKey] || VIP_ICONS.iniciante;
  const Icon = tierConfig.Icon;
  const pct = (profile.score / 1000) * 100;

  return (
    <div
      className="border p-6"
      style={{ background: tierConfig.bg, borderColor: tierConfig.color }}
      data-testid="vip-card"
    >
      <div className="flex items-start justify-between mb-4">
        <div>
          <div className="text-[10px] tracking-[0.2em] uppercase" style={{ color: tierConfig.color }}>Clube VIP</div>
          <div className="font-display text-3xl font-bold tracking-tight mt-1" style={{ color: tierConfig.color }}>
            {profile.tier?.label}
          </div>
        </div>
        <Icon size={42} weight="fill" style={{ color: tierConfig.color }} />
      </div>

      <div className="mb-3">
        <div className="flex justify-between text-xs tracking-widest uppercase mb-2" style={{ color: tierConfig.color }}>
          <span>Score</span>
          <span className="tabular font-bold">{profile.score}/1000</span>
        </div>
        <div className="h-2 bg-white/60 overflow-hidden">
          <div className="h-full" style={{ width: `${pct}%`, background: tierConfig.color }} />
        </div>
      </div>

      <div className="mt-5">
        <div className="text-[10px] tracking-widest uppercase mb-2" style={{ color: tierConfig.color }}>Seus beneficios</div>
        <ul className="space-y-1 text-sm">
          {profile.tier?.perks?.map((p, i) => (
            <li key={i} className="flex items-center gap-2" style={{ color: tierConfig.color }}>
              <span className="w-1 h-1 rounded-full" style={{ background: tierConfig.color }} />
              {p}
            </li>
          ))}
        </ul>
      </div>

      <details className="mt-5 pt-4 border-t" style={{ borderColor: tierConfig.color + "40" }}>
        <summary className="text-[10px] tracking-widest uppercase cursor-pointer" style={{ color: tierConfig.color }}>
          Composicao do score
        </summary>
        <div className="mt-3 space-y-2 text-xs">
          {Object.entries(profile.breakdown || {}).map(([k, v]) => (
            <div key={k} className="flex justify-between" style={{ color: tierConfig.color }}>
              <span className="capitalize">{k.replaceAll("_", " ")}</span>
              <span className="tabular">{v.points}/{v.weight}</span>
            </div>
          ))}
        </div>
      </details>
    </div>
  );
}
